// Friendly labels for backend layer names (the same identifiers used in the
// DEM processing pipeline / layer_status records). Used when surfacing a
// still-processing or failed layer in the folder tree, where no artifact (and
// therefore no display name) exists yet.
const LAYER_DISPLAY_NAMES = {
    elevation: 'Elevation',
    hillshade: 'Hillshade',
    colored_hillshade: 'Colored Hillshade',
    slope: 'Slope',
    aspect: 'Aspect',
    aspectslopecombo: 'Aspect / Slope Composite',
    geomorphons: 'Geomorphons',
    flow_accumulation_twi: 'Flow Accumulation / TWI',
    contours: 'Contours',
    streams: 'Drainage Network',
    watershed_boundaries: 'Watershed Boundaries',
};
// Map a backend layer name to a human-friendly label. Falls back to a
// title-cased version of the raw name for any unmapped layer.
export function getLayerDisplayName(layerName) {
    const known = LAYER_DISPLAY_NAMES[layerName];
    if (known)
        return known;
    return layerName
        .split('_')
        .map(part => (part.length > 0 ? part[0].toUpperCase() + part.slice(1) : part))
        .join(' ');
}
